<template>
  <nw-form
    :nw-form-value="form"
    @nw-form-input="handleNwFormInput"
    ref="nwForm"
  >
    <b-form-group
      id="Height"
      :label="$t('kiosk.height')"
      label-for="Height"
      label-cols="3"
    >
      <validation-provider
        :name="$t('kiosk.height')"
        rules="required|between:50,300"
        #default="{ errors }"
      >
        <b-input-group
          append="cm"
          class="input-group-merge"
        >
          <b-form-input
            id="Height"
            :value="form.Height"
            @input="v => { form.Height = v; emitFormData() }"
          />
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </nw-form>
</template>

<script>
import nwFormTaskTypeMixin from "@/views/kiosk/components/kskNursingWork/mixins/nwFormTaskTypeMixin";

export default {
  name: "NwFormHeight",
  mixins: [nwFormTaskTypeMixin],
}
</script>

<style scoped>

</style>